import { compose, createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import firebase from "../firebase/Firebase";
import rootReducer from "./reducers";
import { getFirebase } from "react-redux-firebase";
import { reduxFirestore, getFirestore } from "redux-firestore";
import { createFirestoreInstance } from "redux-firestore";

const composeEnhancers =
  process.env.NODE_ENV === "development"
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
    : compose;

const rrfConfig = {
  userProfile: "users",
  useFirestoreForProfile: true,
};

export const store = createStore(
  rootReducer,
  composeEnhancers(
    reduxFirestore(firebase),
    applyMiddleware(thunk.withExtraArgument({ getFirebase, getFirestore }))
  )
);

export const rrfProps = {
  firebase,
  config: rrfConfig,
  dispatch: store.dispatch,
  createFirestoreInstance,
};
